import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from 'src/app/layouts/default/default.component';
import { ScreenshotDetailsComponent } from './components/screenshot-details/screenshot-details.component';
import { ScreenshotViewComponent } from './components/screenshot-view/screenshot-view.component';


const routes: Routes = [
   {
       path: '', component:DefaultComponent, children: [
        {
            path: '', component: ScreenshotDetailsComponent
        },
        {
            path: 'screenshot', component: ScreenshotDetailsComponent
        },
        {
            path: 'view/:id', component:  ScreenshotViewComponent
        }
       ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})  
export class ScreenshotRoutingModule { }